import React from 'react'
import PageHeader from '../components/PageHeader'

const Institution_Innovation_Council = () => {
    return (
        <div>
            <PageHeader title=" Institution Innovation Council" />
        </div>
    )
}

export default Institution_Innovation_Council